export const TIMETRACKING_BALANCE_PORT = 'TIMETRACKING_BALANCE_PORT' as const;

export interface VisibleBalance {
  key: string;
  label: string;
  translations: Partial<Record<'de' | 'en' | 'fr' | 'it', { label?: string }>> | null;
  value: number;
  unit: 'hours' | 'days';
}

export interface TimetrackingBalancePort {
  visibleBalances(personId: string): Promise<VisibleBalance[]>;
}
